import React from 'react';
import CategoryCardComponent from '../../../components/organism/CategoryCardComponent/';
import useStyles from './style';
import { COMPONENT_NAME } from './locators';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import aspectRatios from '../../../utils/AspectRatios';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';

const CategoryListing = props => {
  const { fields, sitecoreContext } = props;
  const classes = useStyles();
  const categoryListingTitle = get(
    sitecoreContext,
    'route.fields.categoryListingTitle',
    ''
  );
  const categoryListingDescription = get(
    sitecoreContext,
    'route.fields.categoryListingDescription',
    ''
  );
  //For running this component locally, use mockJSON file to import the props.

  const { categoryList } = fields;

  const customCategoryList =
    categoryList &&
    categoryList.length > 0 &&
    categoryList.map(item => {
      return {
        fields: {
          title: {
            value: item.title,
          },
          imageTextLink: {
            value: {
              href: item.imageTextLink,
            },
          },
          image: { ...item.image },
          mobileImage: { ...item.mobileImage },
        },
      };
    });

  return !isEmpty(fields) ? (
    <div className={classes.root} data-locator={COMPONENT_NAME}>
      <CategoryCardComponent
        tileData={customCategoryList}
        description={categoryListingDescription}
        segmentHeading={categoryListingTitle}
        aspectRatio={aspectRatios['2x1']}
        pageName={getPageName(props)}
        componentName={getComponentName(props)}
      />
    </div>
  ) : null;
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(CategoryListing))
);
